module.exports = __webpack_public_path__ + "b32a74e84e5a180475b42cf9c6cbf236.ttf";